import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

export const ZBattery = z.object({
  kpi_name: z.string(),
  timestamp: z.string(),
  kpi_value: z.number(),
  kpi_units: z.string()
})

const ZBatteryObj = z.object({
  total_count: z.number(),
  kpi_values: z.array(ZBattery)
})

const ZApiResponse = z.object({
  http_status: z.number(),
  data: z.optional(ZBatteryObj),
  error: z.boolean()
})

export type ZBatteryData = z.infer<typeof ZBattery>
export type ZBatteryObject = z.infer<typeof ZBatteryObj>
export type ApiResponse = z.infer<typeof ZApiResponse>

const getSortField = (sortfield: string): string => {
  if (sortfield === 'kpi_timestamp') {
    sortfield = 'kpiTimestamp'
  } else if (sortfield === 'kpi_value') {
    sortfield = 'value'
  }
  return sortfield
}
export async function getBatteryList (
  page: number,
  size: number,
  assetId: string,
  from: string,
  to: string,
  tenantId: string,
  kpiId: string,
  sortField: string,
  sortDir: string,
  onSuccess: (batteryObj: ZBatteryObject, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const encodedFrom = from.replace('+', '%2B')
  const encodedTo = to.replace('+', '%2B')
  const sortFieldParam = getSortField(sortField)

  const url = `/kpi-service/api/v1/udp/kpis/table?kpiList=${kpiId}&assetId=${assetId}&from=${encodedFrom}&to=${encodedTo}&tenantId=${tenantId}&page=${page - 1}&size=${size}&sort=${sortFieldParam},${sortDir}`

  interceptedAxios
    .get(url)
    .then((response) => {
      const parseResponse = ZApiResponse.safeParse(response.data)
      // istanbul ignore next
      if (parseResponse.success) {
        if (parseResponse.data.data !== undefined) {
          onSuccess(parseResponse.data.data, parseResponse.data.http_status)
        } else {
          onFailure({ totalCount: 0, group_details: [] }, response.status)
        }
      } else {
        // onSuccess(mockResponse, 200)
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        // istanbul ignore next
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
